<script>
export default {
  props: {
    header: {
      type: String,
      default: 'หมายเหตุ'
    }
  },

  render() {
    return (
      <div class={this.$style.root}>
        <div class={this.$style.header}>{this.header}</div>
        <div class={this.$style.body}>{this.$slots.default}</div>
      </div>
    )
  }
}
</script>

<style lang="scss" module>
.root {
  padding: 1rem;
  background-color: $--background-color-base;
}

.header {
  font-weight: bold;
  margin-bottom: 0.5rem;
}

.body {
  color: $--color-text-secondary;
}
</style>
